module.exports = __webpack_public_path__ + "img/card_icon_v1_all.013ba19e.svg";